import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "" }) => {
  const mark = light ? "#FFFFFF" : "#0A1128";
  const word = light ? "#FFFFFF" : "#0A1128";
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg width="34" height="34" viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill={light ? "rgba(255,255,255,0.12)" : "#0A1128"} />
        <path d="M18 14h7v26h17v7H18z" fill={mark} />
        <circle cx="44" cy="20" r="6" fill="#007AFF" />
        <path d="M44 20 L25 40" stroke="#007AFF" strokeWidth="2.5" strokeLinecap="round" opacity="0.85" />
      </svg>
      <span className="font-display text-xl font-extrabold tracking-tight leading-none" style={{ color: word }}>
        Lead<span className="text-electric">ITES</span>
      </span>
    </Link>
  );
};
